import React, { useState, useMemo } from 'react';
import { useI18n } from '../i18n/I18nContext';

const PAGE_SIZE = 10;

function PaginatedTable({ data, columns, searchFields, onEdit, onDelete, emptyMessage, extraActions }) {
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const { t } = useI18n();

  const filtered = useMemo(() => {
    if (!search.trim()) return data;
    const q = search.toLowerCase();
    return data.filter((row) =>
      searchFields.some((field) => {
        const val = row[field];
        return val && String(val).toLowerCase().includes(q);
      })
    );
  }, [data, search, searchFields]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const safePage = Math.min(page, totalPages);
  const start = (safePage - 1) * PAGE_SIZE;
  const paged = filtered.slice(start, start + PAGE_SIZE);

  if (page > totalPages) setPage(totalPages);

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
        <input
          placeholder={t('search')}
          value={search}
          onChange={(e) => { setSearch(e.target.value); setPage(1); }}
          style={{ padding: '8px 12px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '14px', minWidth: '250px' }}
        />
        <span style={{ color: '#888', fontSize: '13px' }}>
          {t('results', { n: filtered.length })}
        </span>
      </div>

      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.key} style={{ border: '1px solid #ddd', padding: '10px', textAlign: 'left', background: '#f8f9fa' }}>{col.label}</th>
            ))}
            {(onEdit || onDelete || extraActions) && <th style={{ border: '1px solid #ddd', padding: '10px', textAlign: 'left', background: '#f8f9fa' }}>{t('actions')}</th>}
          </tr>
        </thead>
        <tbody>
          {paged.length === 0 ? (
            <tr><td colSpan={columns.length + (onEdit || onDelete || extraActions ? 1 : 0)} style={{ padding: '20px', textAlign: 'center', color: '#888' }}>{emptyMessage || t('noData')}</td></tr>
          ) : (
            paged.map((row, idx) => (
              <tr key={row.id || idx}>
                {columns.map((col) => (
                  <td key={col.key} style={{ border: '1px solid #ddd', padding: '10px' }}>
                    {col.render ? col.render(row[col.key], row) : row[col.key] ?? '-'}
                  </td>
                ))}
                {(onEdit || onDelete || extraActions) && (
                  <td style={{ border: '1px solid #ddd', padding: '10px', whiteSpace: 'nowrap' }}>
                    {onEdit && <button onClick={() => onEdit(row)} style={{ padding: '4px 8px', background: '#ffc107', border: 'none', borderRadius: '4px', cursor: 'pointer', marginRight: '5px' }}>{t('edit')}</button>}
                    {extraActions && extraActions(row)}
                    {onDelete && <button onClick={() => onDelete(row.id)} style={{ padding: '4px 8px', background: '#dc3545', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>{t('delete')}</button>}
                  </td>
                )}
              </tr>
            ))
          )}
        </tbody>
      </table>

      {totalPages > 1 && (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px', marginTop: '15px' }}>
          <button disabled={safePage <= 1} onClick={() => setPage(safePage - 1)} style={navBtn}>{t('prev')}</button>
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
            <button key={p} onClick={() => setPage(p)} style={{ ...navBtn, ...(p === safePage ? activeBtn : {}) }}>{p}</button>
          ))}
          <button disabled={safePage >= totalPages} onClick={() => setPage(safePage + 1)} style={navBtn}>{t('next')}</button>
        </div>
      )}
    </div>
  );
}

const navBtn = { padding: '6px 12px', border: '1px solid #ddd', borderRadius: '4px', cursor: 'pointer', background: '#fff' };
const activeBtn = { background: '#007bff', color: '#fff', borderColor: '#007bff' };

export default PaginatedTable;
